module.exports = __webpack_public_path__ + "img/FilterAuswahl.ef40c8f2.png";